// ✅ Auto-generated Bootstrap5 components index
import BS5_Alerts from './Bootstrap5_Components/BS5_Alerts.jsx';
import BS5_Badges from './Bootstrap5_Components/BS5_Badges.jsx';
import BS5_BasicTemplate from './Bootstrap5_Components/BS5_BasicTemplate.jsx';
import BS5_ButtonGroups from './Bootstrap5_Components/BS5_ButtonGroups.jsx';
import BS5_Buttons from './Bootstrap5_Components/BS5_Buttons.jsx';
import BS5_Cards from './Bootstrap5_Components/BS5_Cards.jsx';
import BS5_Carousel from './Bootstrap5_Components/BS5_Carousel.jsx';
import BS5_Certificate from './Bootstrap5_Components/BS5_Certificate.jsx';
import BS5_ChecksRadios from './Bootstrap5_Components/BS5_ChecksRadios.jsx';
import BS5_Collapse from './Bootstrap5_Components/BS5_Collapse.jsx';
import BS5_Colors from './Bootstrap5_Components/BS5_Colors.jsx';
import BS5_Containers from './Bootstrap5_Components/BS5_Containers.jsx';
import BS5_DarkMode from './Bootstrap5_Components/BS5_DarkMode.jsx';
import BS5_Dropdowns from './Bootstrap5_Components/BS5_Dropdowns.jsx';
import BS5_Editor from './Bootstrap5_Components/BS5_Editor.jsx';
import BS5_Exercises from './Bootstrap5_Components/BS5_Exercises.jsx';
import BS5_Flex from './Bootstrap5_Components/BS5_Flex.jsx';
import BS5_FloatingLabels from './Bootstrap5_Components/BS5_FloatingLabels.jsx';
import BS5_Forms from './Bootstrap5_Components/BS5_Forms.jsx';
import BS5_FormValidation from './Bootstrap5_Components/BS5_FormValidation.jsx';
import BS5_GetStarted from './Bootstrap5_Components/BS5_GetStarted.jsx';
import BS5_GridBasic from './Bootstrap5_Components/BS5_GridBasic.jsx';
import BS5_GridExamples from './Bootstrap5_Components/BS5_GridExamples.jsx';
import BS5_GridLarge from './Bootstrap5_Components/BS5_GridLarge.jsx';
import BS5_GridMedium from './Bootstrap5_Components/BS5_GridMedium.jsx';
import BS5_GridSmall from './Bootstrap5_Components/BS5_GridSmall.jsx';
import BS5_GridSystem from './Bootstrap5_Components/BS5_GridSystem.jsx';
import BS5_GridXLarge from './Bootstrap5_Components/BS5_GridXLarge.jsx';
import BS5_GridXSmall from './Bootstrap5_Components/BS5_GridXSmall.jsx';
import BS5_GridXXL from './Bootstrap5_Components/BS5_GridXXL.jsx';
import BS5_Home from './Bootstrap5_Components/BS5_Home.jsx';
import BS5_Images from './Bootstrap5_Components/BS5_Images.jsx';
import BS5_InputGroups from './Bootstrap5_Components/BS5_InputGroups.jsx';
import BS5_InterviewPrep from './Bootstrap5_Components/BS5_InterviewPrep.jsx';
import BS5_Jumbotron from './Bootstrap5_Components/BS5_Jumbotron.jsx';
import BS5_ListGroups from './Bootstrap5_Components/BS5_ListGroups.jsx';
import BS5_Modal from './Bootstrap5_Components/BS5_Modal.jsx';
import BS5_Navbar from './Bootstrap5_Components/BS5_Navbar.jsx';
import BS5_Navs from './Bootstrap5_Components/BS5_Navs.jsx';
import BS5_Offcanvas from './Bootstrap5_Components/BS5_Offcanvas.jsx';
import BS5_Pagination from './Bootstrap5_Components/BS5_Pagination.jsx';
import BS5_Popover from './Bootstrap5_Components/BS5_Popover.jsx';
import BS5_ProgressBars from './Bootstrap5_Components/BS5_ProgressBars.jsx';
import BS5_Quiz from './Bootstrap5_Components/BS5_Quiz.jsx';
import BS5_Range from './Bootstrap5_Components/BS5_Range.jsx';
import BS5_Scrollspy from './Bootstrap5_Components/BS5_Scrollspy.jsx';
import BS5_SelectMenus from './Bootstrap5_Components/BS5_SelectMenus.jsx';
import BS5_Spinners from './Bootstrap5_Components/BS5_Spinners.jsx';
import BS5_StackedHorizontal from './Bootstrap5_Components/BS5_StackedHorizontal.jsx';
import BS5_StudyPlan from './Bootstrap5_Components/BS5_StudyPlan.jsx';
import BS5_Syllabus from './Bootstrap5_Components/BS5_Syllabus.jsx';
import BS5_Tables from './Bootstrap5_Components/BS5_Tables.jsx';
import BS5_Toast from './Bootstrap5_Components/BS5_Toast.jsx';
import BS5_Tooltip from './Bootstrap5_Components/BS5_Tooltip.jsx';
import BS5_Typography from './Bootstrap5_Components/BS5_Typography.jsx';
import BS5_Utilities from './Bootstrap5_Components/BS5_Utilities.jsx';

const bootstrap5ComponentsMap = {
  "<BS5_Alerts />": BS5_Alerts,
  "<BS5_Badges />": BS5_Badges,
  "<BS5_BasicTemplate />": BS5_BasicTemplate,
  "<BS5_ButtonGroups />": BS5_ButtonGroups,
  "<BS5_Buttons />": BS5_Buttons,
  "<BS5_Cards />": BS5_Cards,
  "<BS5_Carousel />": BS5_Carousel,
  "<BS5_Certificate />": BS5_Certificate,
  "<BS5_ChecksRadios />": BS5_ChecksRadios,
  "<BS5_Collapse />": BS5_Collapse,
  "<BS5_Colors />": BS5_Colors,
  "<BS5_Containers />": BS5_Containers,
  "<BS5_DarkMode />": BS5_DarkMode,
  "<BS5_Dropdowns />": BS5_Dropdowns,
  "<BS5_Editor />": BS5_Editor,
  "<BS5_Exercises />": BS5_Exercises,
  "<BS5_Flex />": BS5_Flex,
  "<BS5_FloatingLabels />": BS5_FloatingLabels,
  "<BS5_Forms />": BS5_Forms,
  "<BS5_FormValidation />": BS5_FormValidation,
  "<BS5_GetStarted />": BS5_GetStarted,
  "<BS5_GridBasic />": BS5_GridBasic,
  "<BS5_GridExamples />": BS5_GridExamples,
  "<BS5_GridLarge />": BS5_GridLarge,
  "<BS5_GridMedium />": BS5_GridMedium,
  "<BS5_GridSmall />": BS5_GridSmall,
  "<BS5_GridSystem />": BS5_GridSystem,
  "<BS5_GridXLarge />": BS5_GridXLarge,
  "<BS5_GridXSmall />": BS5_GridXSmall,
  "<BS5_GridXXL />": BS5_GridXXL,
  "<BS5_Home />": BS5_Home,
  "<BS5_Images />": BS5_Images,
  "<BS5_InputGroups />": BS5_InputGroups,
  "<BS5_InterviewPrep />": BS5_InterviewPrep,
  "<BS5_Jumbotron />": BS5_Jumbotron,
  "<BS5_ListGroups />": BS5_ListGroups,
  "<BS5_Modal />": BS5_Modal,
  "<BS5_Navbar />": BS5_Navbar,
  "<BS5_Navs />": BS5_Navs,
  "<BS5_Offcanvas />": BS5_Offcanvas,
  "<BS5_Pagination />": BS5_Pagination,
  "<BS5_Popover />": BS5_Popover,
  "<BS5_ProgressBars />": BS5_ProgressBars,
  "<BS5_Quiz />": BS5_Quiz,
  "<BS5_Range />": BS5_Range,
  "<BS5_Scrollspy />": BS5_Scrollspy,
  "<BS5_SelectMenus />": BS5_SelectMenus,
  "<BS5_Spinners />": BS5_Spinners,
  "<BS5_StackedHorizontal />": BS5_StackedHorizontal,
  "<BS5_StudyPlan />": BS5_StudyPlan,
  "<BS5_Syllabus />": BS5_Syllabus,
  "<BS5_Tables />": BS5_Tables,
  "<BS5_Toast />": BS5_Toast,
  "<BS5_Tooltip />": BS5_Tooltip,
  "<BS5_Typography />": BS5_Typography,
  "<BS5_Utilities />": BS5_Utilities,
};

export default bootstrap5ComponentsMap;
